module.exports = __webpack_public_path__ + "static/img/avatar.22592503.png";